import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const TITLE = 'title'
const SUMMARY = 'summary'
const CONTENT_STANDARD = 'content_standard'
const SUBJECT = 'subject'
const GRADE_LEVEL = 'grade_level'
const UNIT = 'unit'
const NUMBER = 'number'
const ESTABLISHED_GOALS = 'established_goals'
const LEARNING_OBJECTIVES = 'learning_objectives'
const PRIOR_KNOWLEDGE = 'prior_knowledge'
const UNDERSTANDINGS = 'understandings'
const ESSENTIAL_QUESTIONS = 'essential_questions'
const KEY_KNOWLEDGE = 'key_knowledge'
const KEY_SKILLS = 'key_skills'
const ASSESSMENT_TYPE = 'assessment_type'
const ASSESSMENT_EVIDENCE = 'assessment_evidence'
const OTHER_EVIDENCE = 'other_evidence'
const DIAGNOSTIC = 'diagnostic'
const SPECIFIC_PLAN = 'specific_plan'
const TOPICS = 'topics'
const OPTIONS = 'options'

/**
 * Form model
 */
const formModel = () => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true
    },
    [SUMMARY]: {
      label: `${t('common.summary')}`,
      name: SUMMARY,
    },
    [CONTENT_STANDARD]: {
      label: `${t('common.content-standard')}`,
      name: CONTENT_STANDARD,
    },
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
      required: true
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
      required: true
    },
    [UNIT]: {
      label: `${t('goalbank.unit')}`,
      name: UNIT,
      required: true
    },
    [NUMBER]: {
      label: `${t('common.lesson-number')}`,
      name: NUMBER,
      required: true
    },
    [ESTABLISHED_GOALS]: {
      label: `${t('lessons.established-goals')}`,
      name: ESTABLISHED_GOALS,
    },
    [LEARNING_OBJECTIVES]: {
      label: `${t('lessons.learning-objectives')}`,
      name: LEARNING_OBJECTIVES,
    },
    [PRIOR_KNOWLEDGE]: {
      label: ``,
      name: PRIOR_KNOWLEDGE,
    },
    [UNDERSTANDINGS]: {
      label: `${t('lessons.understandings')}`,
      name: UNDERSTANDINGS,
    },
    [ESSENTIAL_QUESTIONS]: {
      label: `${t('lessons.essential-questions')}`,
      name: ESSENTIAL_QUESTIONS,
    },
    [KEY_KNOWLEDGE]: {
      label: `${t('lessons.key-knowledge')}`,
      name: KEY_KNOWLEDGE,
    },
    [KEY_SKILLS]: {
      label: `${t('lessons.key-skills')}`,
      name: KEY_SKILLS,
    },
    [ASSESSMENT_TYPE]: {
      label: `${t('lessons.assessment-type')}`,
      name: ASSESSMENT_TYPE,
    },
    [ASSESSMENT_EVIDENCE]: {
      label: `${t('lessons.assessment-evidence')}`,
      name: ASSESSMENT_EVIDENCE,
    },
    [OTHER_EVIDENCE]: {
      label: `${t('lessons.other-evidence')}`,
      name: OTHER_EVIDENCE,
    },
    [DIAGNOSTIC]: {
      label: `${t('lessons.diagnostic')}`,
      name: DIAGNOSTIC,
    },
    [SPECIFIC_PLAN]: {
      label: `${t('lessons.specific-plan')}`,
      name: SPECIFIC_PLAN,
    },
    [TOPICS]: {
      label: `${t('common.topics')}`,
      name: TOPICS,
    },
    [OPTIONS]: {
      label: `${t('lessons.options')}`,
      name: OPTIONS,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [SUBJECT]: null,
  [GRADE_LEVEL]: null,
  [UNIT]: null,
  [NUMBER]: null,
  [TOPICS]: [],
  [OPTIONS]: [],
  [ESTABLISHED_GOALS]: [],
  [TITLE]: '',
  [SUMMARY]: '',
  [CONTENT_STANDARD]: '',
  [LEARNING_OBJECTIVES]: '',
  [PRIOR_KNOWLEDGE]: '',
  [UNDERSTANDINGS]: '',
  [ESSENTIAL_QUESTIONS]: '',
  [KEY_KNOWLEDGE]: '',
  [KEY_SKILLS]: '',
  [ASSESSMENT_TYPE]: null,
  [ASSESSMENT_EVIDENCE]: '',
  [OTHER_EVIDENCE]: '',
  [DIAGNOSTIC]: '',
  [SPECIFIC_PLAN]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [UNIT]: yup.object().nullable().required(`${t('errors.required-error-message')}`),
    [SUBJECT]: yup.object().nullable().required(`${t('errors.required-error-message')}`),
  })

export default formModel
